
import Vue from 'vue';
import Component from 'vue-class-component';
import {Action, Getter} from 'vuex-class';
import {KimlikSeridi} from '@/store/aktifKimlik';

/**
 * Aktif kimlikten FARKLI bir hesap/büro önerisi geldiğinde gösterilen şerit (DEV-2603).
 *
 * Başka bir TCKN'li avukat tarayıcıda giriş yaptığında bot ESKİ kimlikle çalışmaya devam eder
 * ve burada uyarır; kendiliğinden geçmez. 'Geç': süren üst görev eski kimlikle DURAKLATILIR,
 * süren alt görev bitince yeni hesaba geçilir (player durur, Başlat'a kullanıcı basar).
 * 'Yoksay' ve 'Tamam' şeridi gizler (aynı öneri geri gelmez).
 */
@Component({})
export default class KimlikGecisSeridi extends Vue {
  @Getter kimlikSeridi!: KimlikSeridi | null;
  @Action kimlikGecisiniBaslat!: () => Promise<void>;
  @Action kimlikGecisiniYoksay!: () => void;

  get seridi(): KimlikSeridi | null {
    return this.kimlikSeridi;
  }

  gec(): void {
    this.kimlikGecisiniBaslat().catch((e: unknown) => console.error('Kimlik geçişi başarısız.', e));
  }

  kapat(): void {
    this.kimlikGecisiniYoksay();
  }
}
